import { Login } from "Models/Authentication/Login";
import { Action } from "Store/Authentication/node_modules/redux";

export interface IAuthenticationState {
    isAuthorized: boolean | undefined;
    login: Login | undefined;
}

export class AuthenticationState implements IAuthenticationState {
    public isAuthorized = undefined;
    public login = undefined;
}

export const enum ActionTypes {
    UPDATE_TOKEN = "UPDATE_TOKEN",
    VERIFY_VALIDATION = "VERIFY_VALIDATION",
    LOGOUT = "LOGOUT"
}

export interface IUpdateTokenAction extends Action {
    type: ActionTypes.UPDATE_TOKEN;
    data: Login;
}

export interface IVerifyValidationAction extends Action {
    type: ActionTypes.VERIFY_VALIDATION;
    data: boolean;
}

export interface ILogoutAction extends Action {
    type: ActionTypes.LOGOUT;
}

export type AuthenticationActions = IUpdateTokenAction | ILogoutAction | IVerifyValidationAction | ISetRenewTokenAction;


// WEBPACK FOOTER //
// ./src/Store/Authentication/AuthenticationActionTypes.ts